import { segmentSchema } from "@redotech/redo-model/marketing/segments/segment-zod-schema";
import * as z from "zod";

export const getSegmentCount = {
  name: "getSegmentCount" as const,
  input: z.object({
    segment: segmentSchema,
    searchString: z.string().optional(),
  }),
  output: z.object({
    allCount: z.number(),
    emailEligibleCount: z.number(),
    emailSubscriberCount: z.number(),
    smsSubscriberCount: z.number(),
  }),
};
